/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\ServiceGeneral.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 8th September 2023 02:11:01
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import AuthenticationError from "Error/AuthenticationError";
import UserSession from "Utils/UserSession";
import { AxiosResponse } from "axios";

/**
 * Helps manage and centralize common behavior of services
 */
class ServiceGeneral {
  static END = "end";
  static CONTINUE = "continue";

  /**
   * Manage the response of axios (Redirect to login if 401, redirect to page error if 500)
   * @param {Object} data The data returned by axios
   * @param {*} history The history object of react router
   * @returns continue if we should continue operations, end if the compoenent calling this function should stop
   */
  static async handleAxiosResponse(data: AxiosResponse<any, any>) {
    const status = data.status;
    switch (status) {
      case 500:
      case 401:
        throw new AuthenticationError("Identification expired.");
      case 300:
        return ServiceGeneral.END;
      default:
        break;
    }
    return ServiceGeneral.CONTINUE;
  }

  static async manageAxiosResponse(func: Function, ifUnauthorized: Function) {
    try {
      return await func();
    } catch (e: any) {
      const status = e.response?.status;
      switch (status) {
        case 500:
          return ServiceGeneral.END;
        case 502:
        case 401:
          const ret = await UserSession.tokenExpired();
          if (!ret)
            ifUnauthorized();
          return func();
        default:
          break;
      }
    }
    return null;
  }

  /**
   * Check if the server is reached, if yes returns the response otherwise returns a server error like response
   * @param {*} error The axios error
   */
  static interpretError(error: any) {
    if (error.response === undefined || error.response.status === 401)
      throw new AuthenticationError("Identification expired.");

    return error.response;
  }
}

export default ServiceGeneral;
